<template>
  <div class="modal-overlay">
    <div class="modal-content">
      <div class="loading-spinner-container">
        <FwbSpinner size="12" color="red"/>
      </div>
      <div class="loading-text-container">
        {{ props.loadingText }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { FwbSpinner } from 'flowbite-vue';
import { defineProps } from 'vue';

const props = defineProps({
  loadingText: {
    type: String,
    required: false,
    default: '',
  },
});

</script>

<style scoped>
 .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #efefef; /* Semi-transparent black background */
    opacity: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000; /* Ensure it's on top of other content */
  }

  .modal-content {
    text-align: center;
  }

  .loading-spinner-container {
    width: 50px;
    margin-left: auto;
    margin-right: auto;
  }

  .loading-spinner {
    color: #111;
  }

  .loading-text-container {
    color: #324047;
    font-size: 2rem;
    text-align: center;
    width: 100%;
    margin-right: auto;
    margin-left: auto;
  }

  .fill-red-600 {
    fill: #F26147 !important;
  }

  @media only screen and (max-height: 500px) {
    .loading-spinner-container {
      margin-top: 20%;
      margin-bottom: 20px;
    }

    .loading-text-container {
      font-size: 1.3rem;
    }
  }
</style>
